import { CreativeList } from "Components/CreativeList";

const CreativePage = () => <CreativeList />;

export default CreativePage;
